export enum EGoogleRedirectStatus {
  APPROVED = 'approved',
  DENIED = 'denied',
  ERROR = 'error',
}
